import React, { useEffect, useRef, useState } from "react";
import PlayButton from "./play-button";
import { cn } from "@/lib/utils";
import { useInView } from "framer-motion";

interface VideoProps {
  src: string;
  type: string;
}

function Video({ src, type }: VideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const viewRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const inview = useInView(viewRef, {
    amount: 0.6,
  });

  useEffect(() => {
    if (inview && !isPaused) {
      const video = videoRef.current;
      if (!video) return;

      video.play();
      setIsPlaying(true);
      setIsHovering(false);
    } else {
      const video = videoRef.current;
      if (!video) return;

      video.pause();
      setIsPlaying(false);
      setIsHovering(true);
    }
  }, [inview, isPaused]);

  function play() {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
      setIsPaused(false);
    } else {
      video.pause();
      setIsPlaying(false);
      //
      setIsPaused(true);
    }
  }

  return (
    <div
      ref={viewRef}
      className="lavender-carpet relative flex h-[70vh] rounded-[40px] lg:h-[80vh] xl:h-dvh"
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div
          className="z-50 h-full w-full"
          onClick={() => {
            setIsHovering(!isHovering);
            console.log("clicked");
          }}
          style={{
            background:
              "linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), \
           linear-gradient(180deg, rgba(0, 0, 0, 0) 91.28%, #000000 100%), \
           linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 10.47%)",
            visibility: !isHovering ? "hidden" : "visible",
          }}
        />

        <PlayButton
          isPlaying={isPlaying}
          className={cn(
            "absolute z-[100] h-16 w-16 xl:h-20 xl:w-20",
            !isHovering ? "hidden" : "flex",
          )}
          onClick={play}
        />
      </div>
      <video
        ref={videoRef}
        onClick={() => {
          if (!isHovering) {
            setIsHovering(true);
          }
        }}
        playsInline
        muted
        autoPlay={false}
      >
        <source src={src} type={type} />
      </video>

      <div className="pointer-events-none absolute inset-x-0 -top-4 h-1/3 bg-gradient-to-b from-white dark:from-background"></div>
      <div className="pointer-events-none absolute inset-x-0 -bottom-4 h-1/3 bg-gradient-to-t from-white dark:from-background"></div>
    </div>
  );
}

export default Video;
